import React, {Component} from "react";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";
import ConnectsTo from "../ConnectsTo";
import {Button, InputGroup} from "react-bootstrap";
import {FaRegTrashAlt} from "react-icons/fa";


class BiquadFilter extends Component {
  static propTypes = {
    config: PropTypes.object,
    connectables: PropTypes.array,
    deleteTool: PropTypes.func,
    setToolConfig: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {};

    this.setFilterType = this.setFilterType.bind(this);
    this.setFrequency = this.setFrequency.bind(this);
    this.setGain = this.setGain.bind(this);
    this.setQ = this.setQ.bind(this);
    this.setToolId = this.setToolId.bind(this);
  }

  setFilterType = (event) => {
    let config = Object.assign({}, this.props.config);
    config.filterType = event.target.value;
    this.props.setToolConfig(this.props.config.id, config);
  }

  setFrequency = (event) => {
    let config = Object.assign({}, this.props.config);
    config.frequency = parseInt(event.target.value, 10);
    this.props.setToolConfig(this.props.config.id, config);
  }

  setGain = (event) => {
    let config = Object.assign({}, this.props.config);
    config.gain = parseFloat(event.target.value);
    this.props.setToolConfig(this.props.config.id, config);
  }

  setQ = (event) => {
    let config = Object.assign({}, this.props.config);
    config.Q = parseFloat(event.target.value);
    this.props.setToolConfig(this.props.config.id, config);
  }

  setToolId = (event) => {
    const newToolId = event.target.value;
    let config = Object.assign({}, this.props.config);
    config.id = newToolId;
    this.props.setToolConfig(this.props.config.id, config);
  }

  render() {
    return (
        <div className={"oscillator toolChainTool"}>
          <h3>BiquadFilter</h3>
          <Button variant={"danger"} onClick={() => {this.props.deleteTool(this.props.config.id)}}><FaRegTrashAlt /></Button>
          <InputGroup>
            <InputGroup.Text>id</InputGroup.Text>
            <Form.Control type="text" value={this.props.config.id}
                          onChange={this.setToolId}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Filter Type</InputGroup.Text>
            <Form.Select value={this.props.config.filterType}
                         onChange={this.setFilterType}>
              <option>lowpass</option>
              <option>highpass</option>
              <option>bandpass</option>
              <option>lowshelf</option>
              <option>highshelf</option>
              <option>peaking</option>
              <option>notch</option>
              <option>allpass</option>
            </Form.Select>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Frequency</InputGroup.Text>
            <Form.Control type="number" min={1} max={20000} step={100}
                value={this.props.config.frequency}
                onChange={this.setFrequency}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Q</InputGroup.Text>
            <Form.Control type="number" min={0} max={100} step={0.5}
                        value={this.props.config.Q}
                        onChange={this.setQ}/>
          </InputGroup>
          <InputGroup>
            <InputGroup.Text>Gain</InputGroup.Text>
            <Form.Control type="number" min={0} max={1} step={0.01}
                        value={this.props.config.gain}
                        onChange={this.setGain}/>
          </InputGroup>
          <ConnectsTo
              connectables={this.props.connectables}
              config={this.props.config}
              setToolConfig={this.props.setToolConfig}/>
        </div>
    );
  }
}

export default BiquadFilter;